<template>
    <div class="wjappearance">
            <div class="sreview-header">
                <p class="back" @click="back"><i class="el-icon-back"></i>退出预览</p>
                <p v-if="!isBank" class="header-title-center">提示：当前为预览页面，答案不被记录。</p>
                <p v-else-if="isBank" class="header-title-center">提示：当前为题库预览页面</p>
                <el-button v-if="!isBank" type="primary" @click="publishShare" size="small">发布并分享</el-button>
            </div>
                <div class="tab">
                    <el-radio-group v-model="tabPosition" @change="tabChange">
                        <el-radio-button label="phone">
                            <i class="el-icon-mobile-phone"></i>
                            手机
                        </el-radio-button>
                        <el-radio-button label="computer">
                            <i class="el-icon-monitor"></i>
                            电脑
                        </el-radio-button>
                    </el-radio-group>
                </div>
                <div class="phoneBox flex justify-content" v-if="tabPosition == 'phone'">
                    <div class="phone-bj">
                        <div class="phone-bj-box">
                            <userAnswerPC v-if="isBank" :isBank="isBank" :isPreviewPc="1" :key="1"></userAnswerPC>
							<AppearanceTM :bandingstyle="stylePhone" v-if="!isBank && gainData" :data="data" @submit="submit"></AppearanceTM>
                        </div>
                    </div>
                    <div class="phone-bj-img"></div>
                </div>
                <div class="computerBox" v-if="tabPosition == 'computer'">
                    <el-row :gutter="20" >
                            <div 
                                class="computer-bj" 
                            >
                                <userAnswerPC v-if="isBank" :isBank="isBank" :isPreviewPc="2" :key="2"></userAnswerPC>
								<AppearancePC 
                                    :bandingstyle="style" 
                                    v-if="!isBank && gainData" 
                                    :data="data" 
                                    :path="'/examPreview'" 
                                    @submit="submit"
                                ></AppearancePC>
                            </div>
                    </el-row>
                    
        </div>
    </div>
</template>

<script>

import userAnswerPC from './userAnswerPC.vue'
import AppearancePC from './components/appearancePC.vue'
import AppearanceTM from './components/appearanceTM.vue'
import { mapState } from "vuex";
export default {
    name: 'ExamPreview',
    components:{
        AppearancePC,
        AppearanceTM,
        userAnswerPC
    },
    data() {
        return {
            questionlist: [],
            tabPosition: 'phone',
            stylePhone: {
				subjectColor: '',
				appearancePhone: {
                    buttonContent: '提交',
                    submitButtonColor: '',
                    logoSet: '', //logo
                    headerImg: '', //页眉图片
                    headerState: '', //页眉设置
                    headerType: 0, //头部 文字图片切换
                    headerContent: '', //头部内容
                    titleSize: '', //标题大小
                    headerColor: '', // 头部颜色
                    headerBold: 'normal', //头部加粗
                    headerItalic: 'normal',
                    headerUnderline: 'none',
                    headerAlign: 'left',
                    bgState: 0, //背景图片文字切换
                    bgImg: '', //背景图片
                    bgQuestionnaire: '', //问卷底色
                    bgOpacity: 100, //背景透明度
                    headerBgcolor: '#EFF4FE', //背景颜色
                    bgColor: '#FFFFFF', //背景颜色
                    fontTitleSize: '20',
                    // 项目
                    fontTitleBold: 'normal',
                    fontTitleColor: '',
                    fontTitleItalic: 'normal',
                    fontTitleUnderline: 'none',
                    bgLocation: 'repeat',
                    logoLocation: 'left',
                    displayTitle: 1,
                    displayWelcome: 1,
                    displayQuestionsno: 1,
                    fontWelcomeBold: 'normal',
                    fontWelcomeItalic: 'normal',
                    fontWelcomeUnderline: 'none',
                    fontStemBold: 'normal',
                    fontStemItalic: 'normal',
                    fontStemUnderline: 'none',
                    fontOptionBold: 'normal',
                    fontOptionItalic: 'normal',
                    fontOptionUnderline: 'none',
				}
			},
            style: {
                subjectColor: '',
                appearance: {
                    headerType: 0,
                    headerBold: 'normal',
                    headerItalic: 'normal',
                    headerUnderline: 'none',
                    headerAlign: 'left',
                    headerImg: '',
                    bgState: 0,
                    bgImg: '',
                    headerBgcolor: '#EFF4FE',
                    bgLocation: 'repeat',
                    logoSet: '',
                    logoLocation: 'left',
                    fontTitleSize: '20',
                    fontTitleBold: 'bold',
                    fontTitleItalic: 'normal',
                    fontTitleUnderline: 'none',
                    fontWelcomeBold: 'normal',
                    fontWelcomeItalic: 'normal',
                    fontWelcomeUnderline: 'none',
                    fontStemBold: 'normal',
                    fontStemItalic: 'normal',
                    fontStemUnderline: 'none',
                    fontOptionBold: 'normal',
                    fontOptionItalic: 'normal',
                    fontOptionUnderline: 'none',
                    buttonContent: '提交',
                    displayTitle: 1,
                    displayWelcome: 1,
                    displayQuestionsno: 1,
                    bgOpacity: 100, //背景透明度
                }
			},
            data:{},
            gainData: false,
        }
    },
    computed:{
		...mapState(['examQuestionTypeArr']),
        id(){
            return this.$route.query.id
        },
        isBank(){
            let data = false
            if (this.$route.query.isBank == 'true') {
                data = true
            } else {
                data = false
            }
            return data
        }
	},
    created() {
        console.log(this.id)
        console.log(this.isBank)
        if (!this.isBank) {
            this.getData()
            this.getStyleData()
        }
    },
    methods: {
        tabChange() {
            if (!this.isBank) {
                this.getStyleData()
            }
        },
        publishShare() {
            this.$router.push({ path: "/sendTest" })
        },
		getStyleData() {
			let that = this
			let type = 0
			if (this.tabPosition == 'phone') {
				type = 0
			} else {
				type = 1
			}
			let data = {
				surveyId: this.id,
				type: type,
			}
			let params = {
				that: this,
				url: `${this.$config.service.examfindOneBySurveyId}`,
				method: "POST",
				data: data,
				cb(res) {
                    if (type == 1) {
                        if (that.$functions.isJSON(res.contentjson)) {
                            that.style.appearance = JSON.parse(res.contentjson)
                        }
                    } else {
                        if (that.$functions.isJSON(res.contentjson)) {
                            that.stylePhone.appearancePhone = JSON.parse(res.contentjson)
                        }
                        
                    }
				},
			};
			this.$util.request(params);
		},
        getData() { 
            console.log('获取试题')
			let that = this
			let params = {
				that: this,
				url: `${this.$config.service.examPaperpreview}?id=${this.id}`,
				method: "POST",
				cb(res) {
					let index = 0, arr = [], questionsList = []
					console.log(res)
					that.gainData = true
					that.data = JSON.parse(res.resultBody.tbExamPaper.paperjson)
					that.data.questionsList.forEach((info) => {
						console.log(info.isHideTitle)
						if (info.isHideTitle == false){
							arr.push(info)
							if (that.examQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {
								info.quesIndex = index
								index++
							}
						}
					})
					that.data.questionsList = arr
                    that.setQuesAnswer()
                },
			};
			this.$util.request(params);
        },
        setQuesAnswer() {
            console.log('1231')
			let quesTypeArr = [100, 101, 102, 207];
            this.data.questionsList.forEach((info, index) =>{
                if (this.$functions.isJSON(info)) {
                    info = JSON.parse(info)
                }
                this.$set(info, 'validate', false)
                switch (info.questionsTypeId) {
                    case 101: // 多选
                        this.$set(info, 'userAnswerArr', [])
                        this.$set(info, 'validateMsg', '请选择选项')
                        break;
                    case 100:
                    case 102:
                        this.$set(info, 'userAnswer', '')
                        this.$set(info, 'validateMsg', '请选择一个选项')
                        break;
                    case 207: // 多项填空
                    case 208: // 横向填空
                        this.$set(info, 'userAnswer', 0)
                        if (info.optionList.length > 0) {
                            info.optionList.forEach((item, i) => {
                                this.$set(item, 'userAnswer', '')
                                this.$set(item, 'validate', false)
                                this.$set(item, 'validateMsg', '请输入内容')
                            })
                        }
                        break;
                    case 209: // 绘图题
                        this.$set(info, 'userAnswer', '')
                        this.$set(info, 'validateMsg', '请在上方空白区域进行签名，并点击 【完成】 按钮')
                        break;
                    case 210: // 上传文件
                    case 211: // 上传图片
                        this.$set(info, 'fileList', [])
                        this.$set(info, 'userAnswerArr', '')
                        this.$set(info, 'validateMsg', '请上传文件')
                        break;
                    default:
                        this.$set(info, 'userAnswer', '')
                        this.$set(info, 'validateMsg', '请输入内容')
                }
                
                // 选项是否随机
                if (quesTypeArr.indexOf(info.questionsTypeId) !== -1 && info.optionIfRandom == 1) {
                    if (info.ifFixedLastOption == 1) {
                        // 固定最后一个选项
                        info.optionList = this.optionRandom(info.optionList, 1);
                    } else {
                        info.optionList = this.optionRandom(info.optionList);
                    }
                }
            })
        },
        // 选项随机
		optionRandom(array, state) {
			let res = [],
				random,
				quesArr = [],
				lastOptionArr = [];
			if (state == 1) {
				array.forEach((info, index) => {
					if (index == array.length - 1) {
						lastOptionArr.push(info);
					} else {
						quesArr.push(info);
					}
				});
			} else {
				quesArr = array;
			}
			while (quesArr.length > 0) {
				random = Math.floor(Math.random() * quesArr.length);
				res.push(quesArr[random]);
				quesArr.splice(random, 1);
			}
			return [...res, ...lastOptionArr];
		},
        submit(){
            this.$notify({
                title: '提示',
                message: '当前为预览页面，答案不被记录。'
            });
            console.log('当前为预览页面，答案不被记录。')
        },
        back() {
            this.$router.go(-1)
        },
    }
}
</script>

<style lang="scss" scoped>
.wjappearance {
    min-height: 100vh;
    // text-align: center;
    background-color: whitesmoke;
}
.sreview-header{
  width: 100%;
  padding: 14px 130px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
}
.header-title-center{
  font-size: 14px;
    color: #aaa;
}
.back{
  cursor: pointer;
}
.el-icon-back{
  margin-right: 6px;
  
}
.wjAppearance_center {
  width: 820px;
  margin: auto;
  justify-content: center;
  width: calc(100% - 736px);
  float: left;
  display: flex;
  flex-direction: column;
  
}
.tab {
  padding-top: 30px;
  margin: auto;
  text-align: center;
}
.phoneBox {
	position: relative;
	margin-top: 15px;
	display: flex;
	justify-content: center;
}
.phone-bj-box {
	// margin: 15px 24px 0 23px;
    height: 721px;
    // overflow: hidden;
    border-radius: 18px;
    // height: calc(100vh - 252px);
    // overflow: hidden;
    // padding: 30px 0;
    overflow-y: scroll;
}
.phone-bj-box::-webkit-scrollbar{
    width: 0;
}


.phone-bj {
	width: 375px;
	// height: 756px;
    border-radius: 25px;
    border: 5px solid #ccc;
	/* background: url('~@/assets/examiphone.png') no-repeat center; */
	/* background-size: 100% 100%; */
	/* overflow: hidden; */
}
// .phone-bj-img{
// 	position: absolute;
// 	left: auto;
// 	top:0;
// 	width: 400px;
// 	height: 756px;
// 	margin-left: 200px;
//     margin-right: 200px;
// 	background: url('~@/assets/examiphone.png') no-repeat center;
// 	background-size: 100% 100%;
// 	z-index: 998;
// }
.computerBox {
	// width: 1400px;
	margin: 30px auto 0 auto;
}
.computer-bj {
    // padding: 20px;
	// width: 820px;
	height: auto;
    // background-color: #fff;
    box-sizing: border-box;
}
/deep/.el-drawer__wrapper,/deep/.v-modal{
    border-radius: 20px;
    width: 375px;
    top: 150px;
    left: auto;
    right: auto;
    bottom: auto;
}
/deep/.el-drawer__wrapper,/deep/.el-drawer__container,/deep/.v-modal{
    height: 721px;
}
/deep/.TM-tips-box{
    position: absolute;
    width: calc(375px * 0.88);
    margin: auto;
}
/deep/.content_row{
    width: 100%;
}
/deep/.content{
    width: 100% !important;
    // border-radius: 25px;
    // overflow: hidden;
    height: 100%;
}
/deep/.isWx-content{
    padding: 0 16px;
    box-sizing: border-box;
}

/deep/.isWx-content .isWX-tips-box{
    width: auto;
    top: auto;
    bottom: auto;
    right: auto;
    left: auto;
}
</style>